exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media screen and (max-width: 750px) {\n.leftBox[data-v-f2e26fe0] {\n    width: 100%;\n    margin-top: 0;\n}\n.leftBox .bannerBox[data-v-f2e26fe0] {\n      width: 100%;\n      height: auto;\n}\n.rightBox[data-v-f2e26fe0] {\n    display: none;\n}\n}\n", ""]);

